import React, { Component } from 'react';
import { domainUrl, routeAfterLogin } from '../config/Config';
import { UserId } from '../helpers/User';
import * as Common from '../helpers/Common';
import Footer from '../partials/Footer';

// Assign $ value to use jquery
const $ = window.$;

export default class ChatRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: Common.getUserData("appFullDate", true),
            chatList: []
        };
    }
    getchatList() {
        Common.reactLoader("show", "Please wait...");
        fetch(domainUrl + "user/ecoach/chats", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                user_id: UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {
            Common.reactLoader("hide");
            if (responseJson.status !== 0) {
                this.setState({
                    chatList: responseJson.data
                })
            }
        });
    }
    rateChat() {
        let chatRateForm = $("#chatRateForm").serializeArray(),
            formData = new FormData();
        formData.append("user_id", UserId());
        chatRateForm.map((val) => {
            formData.append(val.name, val.value);
        });
        Common.reactLoader("show");
        fetch(domainUrl + "user/ecoach/rating", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: formData
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 0) {
                Common.message(responseJson.message, responseJson.errors, "error");
            } else {
                Common.message("Success", responseJson.message, "success");
                let userData = Common.parseJwt(Common.getTokenData());
                if (userData.preRoutes.length > 1) {
                    userData.preRoutes.splice(0, 1);
                    Common.setUserData("preRoutes", userData.preRoutes, true);
                    setTimeout(() => {
                        Common.reactLoader("hide");
                        this.props.router.push(userData.preRoutes[0].url);
                    }, 1200);
                } else {
                    Common.setUserData("globalAccess", true, true);
                    setTimeout(() => {
                        Common.setUserData("preRoutes", [], true);
                    }, 500);
                    setTimeout(() => {
                        Common.reactLoader("hide");
                        this.props.router.push(routeAfterLogin);
                    }, 1200);
                }
            }
        });
    }
    componentWillMount() {
        this.getchatList();
    }
    componentDidMount() {
        document.body.className = "inner";
    }
    render() {
        const chatHtml = this.state.chatList.map((val, key) => {
            return <div key={`ratingbox_${key}`} className="ratebox margtop">
                <table cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td colspan="3">Please rate your E-Coach for the chat you had on {val.date} from {val.from} to {val.to}.</td>
                        </tr>
                        <tr>
                            <td colspan="2">Your rating : </td>
                            <td>
                                <input name="chat_id[]" type="hidden" value={val.id} />
                                <select name="chat_rating[]">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        });
        
        return (<div className="row">
            <header>
                <div className="logo"><img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="361&deg;minds&trade;" title="361&deg;minds&trade;" border="0" /></div>
                <div className="top-links reg-page"><img src={process.env.PUBLIC_URL + '/images/calendar_icon.png'} alt="" title="" border="0" /><span>{this.state.date}</span></div>
            </header>
            <section className="maincontent">
                <section className="content">
                    <div className="pageheight">
                        <h1>Rate your E Coach</h1>
                        <form action="#" method="post" id="chatRateForm">
                            {chatHtml}
                        </form>
                        <div className="margtop"></div>
                        <input type="submit" name="btnRate" onClick={() => this.rateChat()} value="Rate" />
                    </div>
                </section>
            </section>
            <Footer />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/ChatRate.js